import { Text } from "react-native-paper";
import { useAppTheme } from "../../../../../useAppTheme";

type Props = {
	text: string;
};

export const SubInstruction = ({ text }: Props) => {
	const theme = useAppTheme();
	return (
		<Text
			style={{
				color: theme.colors.onSurfaceVariant,
				fontWeight: "600",
				fontSize: 13,
			}}
		>
			{text}
		</Text>
	);
};
